window.fit = window.fit || {};

(function($) {

  fit.sidebarWizard = function(root) {
    this.root = root;
    root.find('.js-sidebar-wizard-accordion-toggle').on('click keypress', this._toggle.bind(this));
    $(window).on('resize',this._resize.bind(this));
  }

  fit.sidebarWizard.prototype = {

    _toggle : function(e) {
      var item = $(e.delegateTarget).parent();
      if (item.hasClass('is-open')) {
        item.removeClass('is-open');
        item.find('.js-sidebar-wizard-accordion-body').slideUp(200);
      } else {
        item.addClass('is-open');
        item.find('.js-sidebar-wizard-accordion-body').slideDown(200);
      }
    },
    _resize : function() {
      if (window.innerWidth >= 1024) {
        this.root.find('.sidebar-wizard__section__items__item__accordion--only-accordion-mobile').addClass('is-open');
        this.root.find('.sidebar-wizard__section__items__item__accordion--only-accordion-mobile .js-sidebar-wizard-accordion-body').slideDown(0);
      } else {
        this.root.find('.sidebar-wizard__section__items__item__accordion--only-accordion-mobile').removeClass('is-open');
        this.root.find('.sidebar-wizard__section__items__item__accordion--only-accordion-mobile .js-sidebar-wizard-accordion-body').slideUp(0);
      }
    }
  }

  $('.js-sidebar-wizard').each(function() {
    new fit.sidebarWizard($(this));
  });

})(jQuery);
